import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LineChartDown04 = function LineChartDown04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m3 9 6.6553 4.7538a.5.5 0 0 0 .6442-.0533l3.401-3.401a.5.5 0 0 1 .6442-.0533L21 15M6 21h12c1.6569 0 3-1.3431 3-3V6c0-1.6569-1.3431-3-3-3H6C4.3431 3 3 4.3431 3 6v12c0 1.6569 1.3431 3 3 3"
    })
  }));
};
export default LineChartDown04;